module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "background"
  }, [_c('h3', {
    staticClass: "background__banner home__banner home__banner--panel"
  }, [_vm._v(_vm._s(_vm.banner))])]), _vm._v(" "), (_vm.ready) ? _c('section', {
    staticClass: "author__list"
  }, _vm._l((_vm.authors), function(author) {
    return (!author.hidden) ? _c('div', {
      staticClass: "author"
    }, [_c('figure', {
      staticClass: "author__figure"
    }, [(author.photo) ? _c('img', {
      attrs: {
        "src": author.photo.url,
        "alt": author.photo.alt
      }
    }) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "author__social"
    }, [_vm._l((author.accounts), function(account) {
      return _c('li', {
        staticClass: "author__link"
      }, [_c('a', {
        attrs: {
          "href": account.url,
          "target": "_blank"
        }
      }, [_c('icon', {
        attrs: {
          "id": account.network
        }
      })], 1)])
    }), _vm._v(" "), (author.photo) ? _c('li', {
      staticClass: "author__overflow",
      style: (("background-image:url(" + (author.photo.url) + ");"))
    }) : _vm._e()], 2), _vm._v(" "), _c('h4', {
      staticClass: "author__name"
    }, [_vm._v(_vm._s(author.name))]), _vm._v(" "), _c('h5', {
      staticClass: "author__title"
    }, [_vm._v(_vm._s(author.title))])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35e9c11b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/generic/Authors.vue
// module id = 629
// module chunks = 1